// extracted by mini-css-extract-plugin
export default {"searchBtn":"InputSearch_searchBtn__32FMU"};